import { InputNumber, InputNumberProps } from 'antd';
import React from 'react';

interface IInputCount extends InputNumberProps {
    disabled?: boolean;
}

const InputCount: React.FC<InputNumberProps> = React.forwardRef<InputNumberProps, IInputCount>(
    ({ disabled, ...restProps }, _ref) => {
        return (
            <InputNumber
                disabled={disabled}
                step={1}
                precision={0}
                min={0}
                max={999}
                style={{ width: '100%' }}
                {...restProps}
            />
        );
    },
);

export default InputCount;
